import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { WorkflowhttpService } from "@app/workflow-common/services/workflowhttp.service";
import { Subject } from "rxjs";
import { NodeOptionsObject } from "@app/workflow-common/diagram-view2/models/node.model";
var InstanceHistoryComponent = /** @class */ (function () {
    function InstanceHistoryComponent(_workflowHttpService) {
        this._workflowHttpService = _workflowHttpService;
        this.isLoading = true;
        this.isLoadingDiagramView = false;
        this.currentPage = 1;
        this.pageLimit = 20;
        this.firstTimeLoad = false;
        this.noData = true;
        this.dagrunsItems = [];
        this.objectName = '';
        this.totalEntriesCount = 0;
        this.filterOptions = [];
        this.appliedViewsFilter = [];
        this.selectedItem = undefined;
        this.widthChangeEventSubject = new Subject();
        this.activeDagTasksData = undefined;
        this.infiniteScrollOn = false;
        this.workflowId = undefined;
        this.dagRunId = undefined;
        this.voidCallingOnInit = true;
    }
    InstanceHistoryComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(this.appliedViewsFilter, ' instance');
                        this.param = {
                            page: this.currentPage,
                            limit: this.pageLimit
                        };
                        return [4 /*yield*/, this.getData(true)];
                    case 1:
                        _a.sent();
                        this.nodeOptions = new NodeOptionsObject({
                            objectName: this.objectName,
                            title: this.metaData.title,
                            showAddChild: false,
                            isDraftMode: false,
                            autosave: false,
                            workflowId: this.workflowId,
                            metaData: this.metaData,
                            viewMode: 'history'
                        });
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    InstanceHistoryComponent.prototype.getData = function (resetPage) {
        var _this = this;
        if (resetPage === void 0) { resetPage = false; }
        return new Promise(function (resolve) {
            if (resetPage) {
                _this.currentPage = 1;
                _this.firstTimeLoad = true;
            }
            _this._workflowHttpService.dagRunnersList(_this.workflowId, _this.param).subscribe(function (data) {
                _this.firstTimeLoad = false;
                _this.dagrunsItems = data['dagruns'];
                _this.objectName = data['objectName'];
                _this.totalEntriesCount = parseInt(data['totalCount']);
                _this.filterOptions = data['defaultFilters'];
                if (_this.totalEntriesCount > 0) {
                    _this.noData = false;
                }
                resolve(true);
            });
        });
    };
    InstanceHistoryComponent.prototype.applyFilters = function (filter) {
        this.appliedViewsFilter.push(filter);
        this.setParam(this.appliedViewsFilter);
        this.getData(true);
    };
    InstanceHistoryComponent.prototype.setParam = function (filter) {
        this.param = {
            page: this.currentPage,
            limit: this.pageLimit,
        };
        this.param.filter = filter;
    };
    InstanceHistoryComponent.prototype.removeFilter = function (filter) {
        this.appliedViewsFilter.splice(filter, 1);
        this.setParam(this.appliedViewsFilter);
        this.getData(true);
    };
    InstanceHistoryComponent.prototype.showDiagramHistory = function (item) {
        var _this = this;
        this.selectedItem = item;
        this.isLoadingDiagramView = true;
        this._workflowHttpService.getDagrunTasksList(item.id)
            .subscribe(function (data) {
            var historyItems = data['historyItems'];
            var sourceBlocks = {};
            if (Object.keys(historyItems).length > 0) {
                sourceBlocks = historyItems;
            }
            var activeDagTasksStatus = {
                'dagRunId': item.id,
                'dagSource': data['dagSource'],
                'tasks': sourceBlocks,
            };
            _this.activeDagTasksData = activeDagTasksStatus;
            _this.isLoadingDiagramView = false;
            _this.nodeOptions.tasksStatus = activeDagTasksStatus['tasks'];
        });
    };
    InstanceHistoryComponent.prototype.getPropertyAddress = function (item) {
        var address = item.addressline1;
        if (item.address2) {
            address += ', ' + item.address2;
        }
        if (item.addressline3) {
            address += ', ' + item.addressline3;
        }
        if (item.county) {
            address += ', ' + item.county;
        }
        if (item.town) {
            address += ', ' + item.town;
        }
        if (item.postcode) {
            address += ', ' + item.postcode;
        }
        return address;
    };
    InstanceHistoryComponent.prototype.getDiaryDescription = function (item) {
        var desc = 'Event type: ';
        if (item.type === 1) {
            desc += 'Normal';
        }
        else if (item.type === 3) {
            desc += 'Job number ' + item.tablepkid;
        }
        else if (item.type === 2) {
            desc += 'Estimate number ' + item.tablepkid;
        }
        else if (item.type === 5) {
            desc += 'Opportunity number ' + item.tablepkid;
        }
        return desc;
    };
    InstanceHistoryComponent.prototype.onScrollEnd = function (event) {
        var _this = this;
        if (this.voidCallingOnInit) {
            this.voidCallingOnInit = false;
            return;
        }
        if (this.infiniteScrollOn) {
            return;
        }
        if (this.totalEntriesCount == this.dagrunsItems.length) {
            return;
        }
        this.infiniteScrollOn = true;
        this.currentPage = this.currentPage + 1;
        this.param = {
            page: this.currentPage,
            limit: this.pageLimit
        };
        this._workflowHttpService.dagRunnersList(this.workflowId, this.param).subscribe(function (data) {
            _this.firstTimeLoad = false;
            _this.dagrunsItems = _this.dagrunsItems.concat(data['dagruns']);
            _this.infiniteScrollOn = false;
        });
    };
    return InstanceHistoryComponent;
}());
export { InstanceHistoryComponent };
